export default __webpack_public_path__ + "static/media/hook.png";